export default __webpack_public_path__ + "static/media/Thumbs.94b67773.db";